import { render, staticRenderFns } from "./PagedReader.vue?vue&type=template&id=f24152f6&scoped=true&"
import script from "./PagedReader.vue?vue&type=script&lang=ts&"
export * from "./PagedReader.vue?vue&type=script&lang=ts&"
import style0 from "./PagedReader.vue?vue&type=style&index=0&id=f24152f6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f24152f6",
  null
  
)

export default component.exports